module.exports = __webpack_public_path__ + "img/structures.379de89c.svg";